/* Material */
import useStyles from './styles'

/* Types */
import { imageSrc } from 'src/shared/frontendTypes/images'
import { CSSProperties } from 'react'

/* Functions */
import getImageUrl from 'src/pages/Product/functions/imageUrl'
import getImageAlt from 'src/pages/Product/functions/imageAlt'

/* Components */
import AiGeneratedBadge from 'src/components/AiGeneratedBadge'
import noImage from 'src/images/camera.svg'

const ImagesCarousel: React.FC<{
  images:imageSrc[], 
  productID:number, 
  metaTitle:string,
  heightPx?: number,
  size?: 'xs' | 'sm' | 'md',
  aspectRatio?: string,
  imageMaxSizePercent?: number,
}> = ({ 
  images, 
  productID, 
  metaTitle, 
  heightPx,
  size = 'sm',
  aspectRatio,
  imageMaxSizePercent = 100,
}) => {
  const classes = useStyles()

  const image = images?.[0]
  const imagePath = getImageUrl(image, productID, size)
  const alt = getImageAlt(image, metaTitle)

  const style: CSSProperties = {
    maxWidth: `${imageMaxSizePercent}%`,
    maxHeight: `${imageMaxSizePercent}%`,
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
    objectPosition: 'center',
    padding: '0.55rem',
    backgroundColor: '#fff',
    display: 'block',
    boxSizing: 'border-box',
  }

  return <div
    className={classes.cardMedia}
    title={metaTitle}
    style={{
      ...(heightPx ? { height: heightPx, aspectRatio: 'auto' } : {}),
      ...(aspectRatio ? { aspectRatio } : {}),
    }}
  >
    <img
      alt={alt}
      src={imagePath || noImage.src}
      style={style}
      loading='lazy'
      decoding='async'
    />
    <AiGeneratedBadge aiGenerated={image?.aiGenerated} />
  </div>

  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

}

export default ImagesCarousel
